import { css } from "@emotion/react";
import { breakpoints } from "shared/styles";

const container = css`
  position: sticky;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  background-color: white;

  padding: 40px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const heading = css`
  @keyframes smoothAppear {
    from {
      opacity: 0;
      
    }

    to {
      opacity: 1;
    }
  }

  display: flex;
  opacity: 0;
  align-items: center;
  animation: .5s smoothAppear .5s forwards ease-in;
  img {
    margin-right: 10px;
  }
  
  @media ${breakpoints.fromMed} {
    img {
      margin-right: 20px;
    }
  }
`;

export default { container, heading };
